import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const hash = window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match?.[1];
        if (!sessionId) {
            setError("Oturum bilgisi alınamadı");
            return;
        }
        (async () => {
            try {
                const r = await api.post("/auth/session", { session_id: sessionId });
                setUser(r.data);
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/panel", { state: { user: r.data }, replace: true });
            } catch (e) {
                setError("Giriş yapılamadı. Lütfen tekrar deneyin.");
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
            <div className="flex flex-col items-center gap-4">
                <img src="/logo-icon.png" alt="ATA Angora" className="w-16 h-16 object-contain animate-pulse" />
                {error ? (
                    <p className="text-sm text-destructive" data-testid="auth-error">{error}</p>
                ) : (
                    <p className="text-sm text-muted-foreground">Giriş yapılıyor...</p>
                )}
            </div>
        </div>
    );
}
